import { cn } from '@/lib/utils';
import { CSSProperties } from 'react';

const colors: any = {
  black: '#191711',
  black2: '#212121',
  white: '#ffffff'
};

type IconsProps = {
  name: string;
  size?: string;
  width?: string;
  height?: string;
  fill?: string;
  styles?: CSSProperties;
  className?: string;
  // noHoverEffect?: boolean;
  // handleClick?: () => void;
};

function Icons({
  name,
  size = '24',
  width,
  height,
  fill,
  styles,
  className
  // noHoverEffect,
  // handleClick
}: IconsProps) {
  const getIcon = () => {
    // Default to `currentColor` so monochrome icons inherit the surrounding
    // text color and adapt to light/dark; named keys still map to fixed colors.
    const f: string = fill ? colors[fill] : 'currentColor';

    switch (name) {
      case 'arrow-up':
        return (
          <svg
            height={size}
            width={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.29289 15.7071C4.68342 16.0976 5.31658 16.0976 5.70711 15.7071L12 9.41421L18.2929 15.7071C18.6834 16.0976 19.3166 16.0976 19.7071 15.7071C20.0976 15.3166 20.0976 14.6834 19.7071 14.2929L12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L4.29289 14.2929C3.90237 14.6834 3.90237 15.3166 4.29289 15.7071Z"
              fill={f}
            />
          </svg>
        );
      case 'arrow-down':
        return (
          <svg
            height={size}
            width={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.29289 8.29289C4.68342 7.90237 5.31658 7.90237 5.70711 8.29289L12 14.5858L18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289C20.0976 8.68342 20.0976 9.31658 19.7071 9.70711L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289Z"
              fill={f}
            />
          </svg>
        );
      case 'upload':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 3.00098C15.2761 3.00098 15.5 2.77712 15.5 2.50098C15.5 2.25552 15.3231 2.05137 15.0899 2.00903L15 2.00098H4C3.72386 2.00098 3.5 2.22483 3.5 2.50098C3.5 2.74644 3.67688 2.95059 3.91012 2.99292L4 3.00098H15ZM9.50014 17.9988C9.7456 17.9988 9.9497 17.8218 9.99197 17.5885L10 17.4986L9.996 5.70477L13.6414 9.3531C13.8148 9.52683 14.0842 9.54636 14.2792 9.41154L14.3485 9.35375C14.5222 9.18034 14.5418 8.91094 14.407 8.71595L14.3492 8.64664L9.85745 4.14664C9.78495 4.07401 9.69568 4.02833 9.60207 4.00962L9.49608 3.99987C9.33511 3.99987 9.19192 4.076 9.10051 4.19419L4.64386 8.64607C4.44846 8.84119 4.44823 9.15777 4.64336 9.35317C4.8168 9.52686 5.08621 9.54634 5.28117 9.41148L5.35046 9.35368L8.996 5.71277L9 17.4989C9.00008 17.7751 9.224 17.9988 9.50014 17.9988Z"
              fill={f}
            />
          </svg>
        );
      case 'question':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C17.523 2 22 6.478 22 12C22 17.522 17.523 22 12 22C6.477 22 2 17.522 2 12C2 6.478 6.477 2 12 2ZM12 3.667C7.405 3.667 3.667 7.405 3.667 12C3.667 16.595 7.405 20.333 12 20.333C16.595 20.333 20.333 16.595 20.333 12C20.333 7.405 16.595 3.667 12 3.667ZM12 15.5C12.5523 15.5 13 15.9477 13 16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5C11 15.9477 11.4477 15.5 12 15.5ZM12 6.75C13.5188 6.75 14.75 7.98122 14.75 9.5C14.75 10.5108 14.4525 11.074 13.6989 11.8586L13.5303 12.0303C12.9084 12.6522 12.75 12.9163 12.75 13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5C11.25 12.4892 11.5475 11.926 12.3011 11.1414L12.4697 10.9697C13.0916 10.3478 13.25 10.0837 13.25 9.5C13.25 8.80964 12.6904 8.25 12 8.25C11.3528 8.25 10.8205 8.74187 10.7565 9.37219L10.75 9.5C10.75 9.91421 10.4142 10.25 10 10.25C9.58579 10.25 9.25 9.91421 9.25 9.5C9.25 7.98122 10.4812 6.75 12 6.75Z"
              fill={f}
            />
          </svg>
        );
      case 'log-out':
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.9991 13.6458V4.35503C17.9991 3.2 17.5403 2.09228 16.7236 1.27556C15.9068 0.458832 14.7991 0 13.6441 0C12.4891 0 11.3813 0.458832 10.5646 1.27556C9.74789 2.09228 9.28906 3.2 9.28906 4.35503V5.22603H11.0311V4.35503C11.0311 3.66201 11.3064 2.99738 11.7964 2.50735C12.2864 2.01731 12.9511 1.74201 13.6441 1.74201C14.3371 1.74201 15.0017 2.01731 15.4918 2.50735C15.9818 2.99738 16.2571 3.66201 16.2571 4.35503V13.6458C16.2571 14.3388 15.9818 15.0034 15.4918 15.4934C15.0017 15.9835 14.3371 16.2588 13.6441 16.2588C12.9511 16.2588 12.2864 15.9835 11.7964 15.4934C11.3064 15.0034 11.0311 14.3388 11.0311 13.6458V12.7747H9.28906V13.6458C9.28906 14.8008 9.74789 15.9085 10.5646 16.7252C11.3813 17.5419 12.4891 18.0008 13.6441 18.0008C14.7991 18.0008 15.9068 17.5419 16.7236 16.7252C17.5403 15.9085 17.9991 14.8008 17.9991 13.6458Z"
              fill={f}
            />
            <path
              d="M4.35426 13.7143L5.58528 12.4832L2.97227 9.87023H11.032V8.12822H2.97227L5.58528 5.5152L4.35426 4.28418L0.254728 8.38371C0.0916175 8.54703 0 8.76841 0 8.99922C0 9.23004 0.0916175 9.45142 0.254728 9.61473L4.35426 13.7143Z"
              fill={f}
            />
          </svg>
        );
      case 'spinner':
        return (
          <svg
            className="text-foreground size-5 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
            width={size}
            height={size}
            style={styles}
          >
            <path
              d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 10.4142 3.16421 10.75 2.75 10.75C2.33579 10.75 2 10.4142 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C9.58579 18 9.25 17.6642 9.25 17.25C9.25 16.8358 9.58579 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5Z"
              fill="currentColor"
            />
          </svg>
        );
      case 'tick':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 122.88 101.6"
            width={width || size}
            height={height || size}
            style={styles}
          >
            <title>{'tick'}</title>
            <path
              d="M4.67 67.27c-14.45-15.53 7.77-38.7 23.81-24C34.13 48.4 42.32 55.9 48 61L93.69 5.3c15.33-15.86 39.53 7.42 24.4 23.36L61.14 96.29a17 17 0 0 1-12.31 5.31h-.2a16.24 16.24 0 0 1-11-4.26c-9.49-8.8-23.09-21.71-32.91-30Z"
              style={{
                fill: f || '#10a64a'
              }}
            />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <span
      className={cn(
        'flex items-center',
        {
          // 'cursor-pointer hover:opacity-80': !noHoverEffect
        },
        className
      )}
      style={styles}
      // onClick={() => handleClick?.()}
    >
      {getIcon()}
    </span>
  );
}

export default Icons;
